<h2 mat-dialog-title>
  {{ data?.title || 'FRONTEND.STORE.PRODUCT_DETAILS.PREVIEW_FORMS.ORDER_FORM_PREVIEW' | translate }}
</h2>
<mat-dialog-content>
  <glxy-alert type="info">
    {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PREVIEW_FORMS.ORDER_FORM_PREVIEW_ALERT' | translate }}
  </glxy-alert>
  <div class="order-form-width">
    <form [formGroup]="form" class="order-form-container">
      <store-order-form
        [fileUploadUrl]="'fake-url'"
        [orderFormOptions]="orderFormOptions"
        [orderForms]="orderForms"
        [parentForm]="form"
        [productInfo]="productInfo"
        [users]="sampleUserList"
      ></store-order-form>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button (click)="close()" mat-stroked-button>Close</button>
</mat-dialog-actions>
